import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, IDFormatter, IntegerFormatter, StringFormatter, StringFormatterSizeType, URLFormatter } from "namirasoft-site-react";
import { IEntityInfo, NSARouterMakerProps } from "namirasoft-account-react";
import { JobArrangerRoutes } from "./JobArrangerRoutes";
import { JobInputRow, JobRow, ReasonInputRow, ReasonRow } from "namirasoft-job-arranger";
import { JobArrangerProps } from "./JobArrangerProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class JobArrangerEntities
{
	static job(props: NSARouterMakerProps & JobArrangerProps): IEntityInfo<JobRow, JobInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_JOB_ARRANGER,
			name: "job",
			tables: [{ table: namirasoft.job_arranger.tables.job, required: true }],
			client: {
				getListURL: () => JobArrangerRoutes.JobList,
				getNewURL: () => JobArrangerRoutes.JobNew,
				getCopyURL: (id: string) => JobArrangerRoutes.JobCopy(id),
				getEditURL: (id: string) => JobArrangerRoutes.JobEdit(id),
				getViewURL: (id: string) => JobArrangerRoutes.JobView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.platform, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.status, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.company, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.location, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.remote, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.min, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.max, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.url, new URLFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.reason_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.sid, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.job.columns.updated_at, new DateTimeFormatter()),
					]
				}
			},
			server: {
				value_list: props.servers.job_arranger.value.List,
				get: props.servers.job_arranger.job.Get,
				list: props.servers.job_arranger.job.List,
				create: null,
				update: props.servers.job_arranger.job.Set,
				delete: props.servers.job_arranger.job.Delete,
			}
		};
	}

	static reason(props: NSARouterMakerProps & JobArrangerProps): IEntityInfo<ReasonRow, ReasonInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_JOB_ARRANGER,
			name: "reason",
			tables: [{ table: namirasoft.job_arranger.tables.reason, required: true }],
			client: {
				getListURL: () => JobArrangerRoutes.ReasonList,
				getNewURL: () => JobArrangerRoutes.ReasonNew,
				getCopyURL: (id: string) => JobArrangerRoutes.ReasonCopy(id),
				getEditURL: (id: string) => JobArrangerRoutes.ReasonEdit(id),
				getViewURL: (id: string) => JobArrangerRoutes.ReasonView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.status, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.job_arranger.tables.reason.columns.updated_at, new DateTimeFormatter()),
					]
				}
			},
			server: {
				value_list: props.servers.job_arranger.value.List,
				get: props.servers.job_arranger.reason.Get,
				list: props.servers.job_arranger.reason.List,
				create: props.servers.job_arranger.reason.Create,
				update: props.servers.job_arranger.reason.Update,
				delete: props.servers.job_arranger.reason.Delete,
			}
		};
	}
}